import axios from 'axios';
import store from '@/store';
import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import { Mutations, Actions, Endpoints } from '@/ts/store/Constants';
import ErrorResponse from '@/ts/ErrorResponse';
import UserInquiryType from '@/ts/UserInquiryType';
import UserInquiryCategory from '@/ts/UserInquiryCategory';
import UserInquiry from '@/ts/UserInquiry';
import UserInquiryAnswer from '@/ts/UserInquiryAnswer';

@Module({name: 'UserTicketsAttributes', namespaced: true})
export default class UserTicketsAttributes extends VuexModule {
    public inquiryTypes: UserInquiryType[] = [];
    public inquiryCategories: UserInquiryCategory[] = [];
    public inquiries: UserInquiry[] = [];
    public inquiryAnswer: UserInquiryAnswer = null;

    @Mutation
    public RESET_USER_TICKETS_ATTRIBUTES_STORE_STATE() {
        this.inquiryTypes      = [];
        this.inquiryCategories = [];
        this.inquiries         = [];
        this.inquiryAnswer     = null;
    }

    get getInquiryTypes(): UserInquiryType[] {
        return this.inquiryTypes;
    }

    get getInquiryTypeById(): any {
        return ((typeId: number) => {
            return this.inquiryTypes.find((type: UserInquiryType) => type.id === typeId);
        });
    }

    get getInquiryCategories(): UserInquiryCategory[] {
        return this.inquiryCategories;
    }

    get getTypeInquiryCategories(): any {
        return ((typeId: number) => {
            return this.inquiryCategories.filter((category: UserInquiryCategory) => category.typeId === typeId);
        });
    }

    get getTypeInquiryCategoryById(): any {
        return ((categoryId: number) => {
            return this.inquiryCategories.find((category: UserInquiryCategory) => category.id === categoryId);
        });
    }

    get getCategoryInquiries(): any {
        return ((categoryId: number) => {
            return this.inquiries.filter((inquiry: UserInquiry) => inquiry.categoryId === categoryId);
        });
    }

    get getInquiries(): UserInquiry[] {
        return this.inquiries;
    }

    get getInquiryAnswer(): UserInquiryAnswer {
        return this.inquiryAnswer;
    }

    @Action
    public FETCH_INQUIRY_TYPES() {
        axios.get(Endpoints.Tickets.USER_INQUIRY_TYPES)
            .then((response: any) => {
                store.commit(Mutations.SET_INQUIRY_TYPES, response.data.data);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public FETCH_INQUIRY_CATEGORIES() {
        axios.get(Endpoints.Tickets.USER_INQUIRY_CATEGORIES)
            .then((response: any) => {
                store.commit(Mutations.SET_INQUIRY_CATEGORIES, response.data.data);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public FETCH_INQUIRIES() {
        axios.get(Endpoints.Tickets.USER_INQUIRY_QUESTIONS)
            .then((response: any) => {
                store.commit(Mutations.SET_INQUIRIES, response.data.data);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public FETCH_INQUIRY_ANSWER(inquiryId: number) {
        axios.get(Endpoints.Tickets.USER_INQUIRY_ANSWER(inquiryId))
            .then((response: any) => {
                store.commit(Mutations.SET_INQUIRY_ANSWER, response.data.data);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Mutation
    public SET_INQUIRY_TYPES(types: any) {
        this.inquiryTypes = [];

        for (const type of types) {
            this.inquiryTypes.push(new UserInquiryType(
                type.id,
                type.key,
                type.descriptions,
            ));
        }
    }

    @Mutation
    public SET_INQUIRY_CATEGORIES(categories: any) {
        this.inquiryCategories = [];

        for (const category of categories) {
            this.inquiryCategories.push(new UserInquiryCategory(
                category.id,
                category.typeId,
                category.descriptions,
            ));
        }
    }

    @Mutation
    public SET_INQUIRIES(inquiries: any) {
        this.inquiries = [];

        for (const inquiry of inquiries) {
            this.inquiries.push(new UserInquiry(
                inquiry.id,
                inquiry.typeId,
                inquiry.categoryId,
                inquiry.key,
                inquiry.descriptions,
            ));
        }
    }

    @Mutation
    public SET_INQUIRY_ANSWER(answer: any) {
        this.inquiryAnswer = new UserInquiryAnswer(answer.id, answer.answers);
    }

    @Mutation
    public RESET_INQUIRY_ANSWER() {
        this.inquiryAnswer = null;
    }
}
